import { Command } from 'commander';
import inquirer from 'inquirer';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { resolveUserIdByEmail } from '../_members-resolver.js';
import { addGridOption, gridSlug, type GridOpts } from '../../grid-opt.js';

const ROLES = ['admin', 'developer', 'viewer', 'publisher'] as const;

interface RoleOpts extends GridOpts { skipConfirm?: boolean; }

export async function runAdminMemberRole(email: string, role: string, opts: RoleOpts, client?: IV2Client): Promise<void> {
  if (!ROLES.includes(role as any)) {
    const { V2ApiError } = await import('../../api/v2-errors.js');
    throw new V2ApiError(400, 'VALIDATION_FAILED', `Role must be one of: ${ROLES.join(', ')}.`);
  }
  if (!opts.skipConfirm) {
    const { ok } = await inquirer.prompt([{ type: 'confirm', name: 'ok',
      message: `Set ${email}'s role to ${role}?`, default: false }]);
    if (!ok) { process.stdout.write('Cancelled.\n'); return; }
  }
  const c = client ?? await getV2Client(gridSlug(opts));
  const userId = await resolveUserIdByEmail(c, email);
  await c.patch(`/api/v2/members/${userId}`, { role });
  process.stdout.write(`✓ Updated role for ${email} to ${role}.\n`);
}

export const adminMemberRoleCommand = new Command('member-role')
  .description(`Change a member's role (admin only)`)
  .argument('<email>', 'Email of member')
  .argument('<role>', `One of: ${ROLES.join(', ')}`)
  .option('--skip-confirm', "Don't prompt");
addGridOption(adminMemberRoleCommand, 'Override active grid');
adminMemberRoleCommand
  .action(async (email: string, role: string, opts: RoleOpts) => {
    try { await runAdminMemberRole(email, role, opts); }
    catch (err) { await handleV2Error(err); }
  });
